import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  Container,
  Stack,
  useTheme,
} from "@mui/material";
import { Fade } from "react-awesome-reveal";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";

// ✅ JS puro (sin TS en la firma)
const getYouTubeId = (url) => {
  if (!url) return null;
  const m =
    url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|shorts\/|watch\?v=|watch\?.+&v=))([^?&/]+)/i
    ) || [];
  return m[1] || null;
};

export default function VideoSection({
  id = "read",
  videoUrl,
  sideImage,
  onCalendarClick,
}) {
  console.log(
    "[VideoSection] sideImage prop =",
    sideImage,
    "typeof:",
    typeof sideImage
  );
  const theme = useTheme();
  const ytId = useMemo(() => getYouTubeId(videoUrl), [videoUrl]);

  const scrollToContact = () => {
    const target = document.getElementById("sabermas");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  // 🔎 diagnóstico rápido
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.log(
      "[VideoSection] sideImage =",
      sideImage,
      "typeof:",
      typeof sideImage
    );
  }

  const isStringUrl =
    typeof sideImage === "string" && sideImage.trim().length > 0;
  const isElement = React.isValidElement(sideImage);
  const isComponent =
    !!sideImage &&
    (typeof sideImage === "function" ||
      (typeof sideImage === "object" && !isElement));
  const SideComp = !isStringUrl && !isElement && isComponent ? sideImage : null;

  return (
    <Box
      component="section"
      aria-labelledby={`${id}-title`}
      sx={{
        py: { xs: 6, md: 6 },
        background:
          theme.palette.mode === "dark"
            ? "linear-gradient(180deg, rgba(255,255,255,.02), rgba(255,255,255,.04))"
            : "linear-gradient(180deg, #FAFBFC, #FFFFFF)",
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          alignItems="center"
          // spacing ahora se separa en row/column si querés
          columnSpacing={{ xs: 3, md: 20}}
          rowSpacing={{ xs: 3, md: 6 }}
          sx={{ px: { xs: 0, md: 0 } }}
        >
          {/* Columna Video */}
          <Grid
            size={{ xs: 12, md: 6 }} // 👈 reemplaza item xs md
            sx={{ order: { xs: 1, md: 1 } }} // 👈 order va en sx
          >
            <Fade triggerOnce>
              <Stack spacing={{ xs: 2, md: 3 }}>
                <Typography
                  id={`${id}-title`}
                  variant="h3"
                  sx={{
                    color: "text.primary",
                    fontSize: { xs: "2rem", md: "2.4rem", xl: "3rem" },
                    lineHeight: 1.1,
                    fontWeight: 800,
                  }}
                >
                  ¿Cómo?
                </Typography>

<Box
  sx={{
    position: "relative",
    width: "100%",
    maxWidth: { xs: "100%", md: 500 }, // 👈 más chico en desktop
    mx: { xs: "auto", md: 0 },
    borderRadius: 2.5,
    overflow: "hidden",
    boxShadow: theme.palette.mode === "dark"
      ? "0 12px 40px rgba(0,0,0,.5)"
      : "0 12px 40px rgba(0,0,0,.12)",
    outline: theme.palette.mode === "dark"
      ? "1px solid rgba(255,255,255,.06)"
      : "1px solid rgba(0,0,0,.06)",
  }}
>
  {ytId ? (
    <LiteYouTube id={ytId} title="Video" />
  ) : (
    <Box
      component="iframe"
      src={videoUrl}
      title="Video"
      loading="lazy"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      sx={{ display: "block", width: "100%", aspectRatio: "16/9", border: 0 }}
    />
  )}
</Box>
                {/* CTAs (tal cual los tenés) */}
                <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
                  <Button
                    onClick={onCalendarClick}
                    variant="contained"
                    size="large"
                    startIcon={
                      <CalendarMonthRoundedIcon sx={{ color: "inherit" }} />
                    }
                    sx={{
                      borderRadius: "20px",
                      px: 3,
                      py: 1.25,
                      minHeight: 44,
                      bgcolor: "#F35A3A",
                      color: "#fff",
                      boxShadow: "0 4px 12px rgba(243,90,58,0.35)",
                      transition:
                        "transform .25s ease, box-shadow .25s ease, background-color .25s ease, color .25s ease",
                      "& .MuiButton-startIcon > *": {
                        color: "inherit",
                        transition: "color .25s ease",
                      },
                      "&:hover": {
                        transform: "scale(1.05)",
                        boxShadow: "0 6px 16px rgba(243,90,58,0.45)",
                        bgcolor: "#F35A3A",
                      },
                      fontWeight: 800,
                    }}
                  >
                    Agendar una cita
                  </Button>

                  <Button
                    onClick={scrollToContact}
                    variant="outlined"
                    size="large"
                    sx={{
                      borderRadius: "20px",
                      px: 3,
                      py: 1.25,
                      minHeight: 44,
                      letterSpacing: 0.6,
                      fontWeight: 700,
                      color: "#F35A3A",
                      borderColor: "#F35A3A",
                      boxShadow: "0 4px 12px rgba(243,90,58,0.15)",
                      transition:
                        "transform .25s ease, box-shadow .25s ease, background-color .25s ease, color .25s ease, border-color .25s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                        boxShadow: "0 6px 16px rgba(243,90,58,0.25)",
                        bgcolor: "#F35A3A",
                        color: "#fff",
                        borderColor: "#F35A3A",
                      },
                    }}
                  >
                    ¡Empecemos ya!
                  </Button>
                </Stack>
              </Stack>
            </Fade>
          </Grid>

          {/* Imagen */}
          <Grid
            size={{ xs: 12, md: 6 }} // 👈 reemplaza item xs md
            sx={{ order: { xs: 2, md: 2 } }} // 👈 order en sx
          >
{isStringUrl && (
  <Box
    sx={{
      // el contenedor solo mide lo que mide la imagen
      width: "fit-content",
      mx: { xs: "auto", md: 0 },   // centrado en mobile
      borderRadius: 3,
      overflow: "hidden",
      boxShadow:
        theme.palette.mode === "dark"
          ? "0 16px 60px rgba(0,0,0,.55)"
          : "0 16px 60px rgba(0,0,0,.14)",
    }}
  >
    <Box
      component="img"
      src={sideImage}
      alt=""
      loading="lazy"
      decoding="async"
      sx={{
        display: "block",
        // altura controlada, ancho automático según aspecto
        height: { xs: 260, sm: 320, md: 420 },
        width: "auto",
        maxWidth: "100%",       // por si en mobile no entra
        objectFit: "cover",
        objectPosition: "center",
      }}
    />
  </Box>
)}


            {isElement && (
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: { xs: 260, sm: 320, md: 420 },
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow:
                    theme.palette.mode === "dark"
                      ? "0 16px 60px rgba(0,0,0,.55)"
                      : "0 16px 60px rgba(0,0,0,.14)",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    display: "grid",
                    placeItems: "center",
                    p: 2,
                  }}
                >
                  {React.cloneElement(sideImage, {
                    style: {
                      maxWidth: "100%",
                      maxHeight: "100%",
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    },
                  })}
                </Box>
              </Box>
            )}

            {SideComp && (
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: { xs: 260, sm: 320, md: 420 },
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow:
                    theme.palette.mode === "dark"
                      ? "0 16px 60px rgba(0,0,0,.55)"
                      : "0 16px 60px rgba(0,0,0,.14)",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    display: "grid",
                    placeItems: "center",
                    p: 2,
                  }}
                >
                  <SideComp
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              </Box>
            )}

            {/* 🛟 Fallback visible si no vino nada */}
            {!isStringUrl && !isElement && !SideComp && (
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: { xs: 260, sm: 320, md: 420 },
                  borderRadius: 3,
                  border: "1px dashed rgba(0,0,0,.2)",
                  display: "grid",
                  placeItems: "center",
                  color: "text.secondary",
                  background:
                    theme.palette.mode === "dark"
                      ? "rgba(255,255,255,0.04)"
                      : "rgba(0,0,0,0.02)",
                }}
              >
                <Typography variant="body2">sideImage no provisto</Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

// JS puro (sin TS en la firma)
function LiteYouTube({ id, title }) {
  const [play, setPlay] = useState(false);
  const poster = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
  const src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`;
  if (play) {
    return (
      <Box
        component="iframe"
        src={src}
        title={title || "YouTube video"}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        sx={{ display: "block", width: "100%", aspectRatio: "16/9", border: 0 }}
      />
    );
  }
  return (
    <Box
      onClick={() => setPlay(true)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) =>
        e.key === "Enter" || e.key === " " ? setPlay(true) : null
      }
      aria-label="Reproducir video"
      sx={{
        position: "relative",
        width: "100%",
        aspectRatio: "16/9",
        backgroundImage: `url(${poster})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        cursor: "pointer",
        outline: "none",
      }}
    >
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{ position: "absolute", inset: 0 }}
      >
        <Box
          sx={{
            width: 82,
            height: 82,
            borderRadius: "999px",
            background: "rgba(255,255,255,.9)",
            display: "grid",
            placeItems: "center",
            boxShadow: "0 10px 30px rgba(0,0,0,.25)",
          }}
        >
          <PlayArrowRoundedIcon sx={{ fontSize: 48, color: "black" }} />
        </Box>
        <Typography
          variant="caption"
          sx={{
            mt: 1.2,
            px: 1,
            py: 0.4,
            borderRadius: 1,
            bgcolor: "rgba(0,0,0,.55)",
            color: "#fff",
          }}
        >
          CONOCENOS MEJOR
        </Typography>
      </Stack>
    </Box>
  );
}
